import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import ContactNameModel from '../../ContactSelector/models/ContactNameModel';
import ContactQueryModel from '../models/ContactQueryModel';
import ContactModel from '../models/ContactModel';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';

interface contactSearchState {
    query: ContactQueryModel,
    searchResults: ContactModel[],
    contactSearchKeyword: string,
    contactAccountNames: ContactNameModel[],
    triggerSearch: number,
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedContacts: ContactModel[],
}

const initialState: contactSearchState = {
    query: {
        companyNames: [],
        companyTypes: [],
        countries: [],
        interests: [],
        sizeFocuses: [],
        dateUpdated: 0,
        inactiveDate: "",
        emails: [],
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as ContactQueryModel,
    searchResults: [],
    contactSearchKeyword: "",
    contactAccountNames: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedContacts: [],
}

export const ContactSearchSlice = createSlice({
    name: "ContactSearch",
    initialState,
    reducers: {
        setCompanyNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.companyNames = action.payload;
        },
        setCompanyTypes: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.companyTypes = action.payload;
        },
        setInterests: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.interests = action.payload;
        },
        setEmails: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.emails = action.payload;
        },
        setSizeFocuses: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.sizeFocuses = action.payload;
        },
        setCountries: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.countries = action.payload;
        },
        setDateUpdated: (state, action: PayloadAction<number>) => {
            state.query.dateUpdated = action.payload;
        },
        setInactiveDate: (state, action: PayloadAction<string>) => {
            state.query.inactiveDate = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setContactSearchResults: (state, action: PayloadAction<ContactModel[]>) => {
            state.searchResults = action.payload;
        },
        setContactContactSearchKeyword: (state, action: PayloadAction<string>) => {
            state.contactSearchKeyword = action.payload;
        },
        setTriggerContactSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setDatatableSelectedContactIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setContactquery: (state, action: PayloadAction<ContactQueryModel>) => {
            state.query = action.payload;
        },
        resetContactSearch: (state) => {
            state.query = initialState.query;
        },
        setContactAccountNames: (state, action: PayloadAction<ContactNameModel[]>) => {
            state.contactAccountNames = action.payload;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedContacts: (state, action: PayloadAction<ContactModel[]>) => {
            state.checkedContacts = action.payload;
        },

    }
});

export const ContactSearchSelector = createSelector(
    (state: RootState) => state.contactSearch,
    (data) => data
);

export const {
    setCompanyNames,
    setCompanyTypes,
    setCountries,
    setInterests,
    setEmails,
    setSizeFocuses,
    setDateUpdated,
    setInactiveDate,
    setOrderBy,
    setOrderDirection,
    setContactSearchResults,
    setContactContactSearchKeyword,
    setTriggerContactSearch,
    setDatatableSelectedContactIndex,
    setSearchResultTotalRecord,
    setContactquery,
    resetContactSearch,
    setContactAccountNames,
    setTriggerFocusCompanyName,
    setCheckedContacts
} = ContactSearchSlice.actions;

export default ContactSearchSlice.reducer;